export default __webpack_public_path__ + "static/media/one.79a1e10d.png";